import { Box, Grid } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from "react";
import CustomFormLabel from "../../common/form-label/CustomFormLabel ";
import CustomInput from "../../common/textField/CustomInput";
import CustomDialog from "../../common/dialog/CustomDialog";
import BasicButton from "../../common/button/BasicButton";
import CustomTree from "../../common/custom-tree/CustomTree";
import { getCategoryByTypeId } from "../../../redux/actions/SystemManagement/AddCategory";
import { useDispatch } from "react-redux";
import { getCategoryByID } from "../../../redux/actions/TicketsManagement/TicketsManagement";

function CloseCategoryOption({
  ticketTypeId,
  gridCol = 4,
  isGridTag = false,
  onSelectOutcome,
  outComeCategoryId,
  isError = false,
  setHasOutcomeCategory
}: {
  ticketTypeId: any;
  gridCol?: number;
  isGridTag?: boolean;
  onSelectOutcome: (id: any) => void;
  outComeCategoryId: any;
  isError?: boolean;
  setHasOutcomeCategory?: (val:boolean)=>void;
}) {
  const dispatch = useDispatch();
  const [addCategoryPopup, setAddCategoryPopup] = useState(false);
  const [showField, setShowField] = useState<boolean>(false);
  const [categoryVal, setcategoryVal] = React.useState<any>({});
  const [value, setValue] = React.useState<any>({});
  // console.log("ticketInfo?.ticketLogs?.agentId", outComeCategoryId);
  useEffect(() => {
    if (outComeCategoryId)
      dispatch(getCategoryByID(outComeCategoryId, getOutComeCB));
  }, [outComeCategoryId]);
  const getOutComeCB = (res: any) => {
    console.log("getOutComeCB", res);
    const temp = { ...res, label: res.name, value: res.name };
    setValue(temp);
    onSelectOutcome(temp?.id);
  };
  useEffect(() => {
    setValue(null);
    if (ticketTypeId) {
      dispatch(getCategoryByTypeId(ticketTypeId, singleCategoryCB, true));
    } else {
      setShowField(false);
    }
  }, [ticketTypeId]);

  const singleCategoryCB = (res: {
    isSuccess: boolean;
    data: any;
    statusCode: any;
  }) => {
    const { isSuccess, data = {} } = res;
    // setShowField(isSuccess && Object.keys(data).length > 0);
    const fieldExists = isSuccess && Object.keys(data).length > 0;
    setShowField(fieldExists);
    if(setHasOutcomeCategory){
        setHasOutcomeCategory(fieldExists);
    }
    if (isSuccess) {
      setcategoryVal(data);
    }
  };
  const handleCategorySelection = (val: any) => {
    setValue(val);
    onSelectOutcome(val?.id);
  };
  // if (loading) {
  //   return <div>Loading...</div>
  // }
  const returnComponent = (component: JSX.Element) => {
    return (
      <>
        {showField && (
          <>
            {isGridTag ? (
              <Grid item md={gridCol}>
                <br />
                {component}
              </Grid>
            ) : (
               <Box
                  sx={{
                    flex: '1 1 calc(50% - 16px)',
                                   
                  }}
                >{component}</Box>
            )}
          </>
        )}
      </>
    );
  };
  return (
    <>
      {returnComponent(
        <>
          <Box>
            <input type="text"  value={value?.id || ""} name="closeCategoryID" id="closeCategoryID" aria-hidden={true} className="d-none" />
            <CustomFormLabel labelName={"Outcomes"} isMandotary={true} />
            <CustomInput
              isDisabled={false}
              readOnly={true}
              // iconPosition={"end"}
              // icon={false}
              icon={
                value?.label ? (
                  <CloseIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      setValue(null);
                      onSelectOutcome(null);
                    }}
                    sx={{
                      position: "absolute",
                      right: "12px",
                      cursor: "pointer",
                      fontSize: 18,
                      color: "#333"
                    }}
                  />
                ) : null
              }
              isError={isError}
              label={"Outcomes"}
              name="closeCategory"
              value={value?.label || ""}
              onClick={() => {
                setAddCategoryPopup(true);
              }}
              onChange={() => {}}
              helperText={""}
              placeholder={"Click here to choose an outcome"}
            />
            {isError && !value?.label && (
              <CustomFormLabel
                classNames="txt-danger"
                labelName={"Please Choose Outcome"}
                isMandotary={false}
                fontSize="12px"
              />
            )}
          </Box>
          <CustomDialog
            heading="Outcome"
            className="outcome-popup"
            body={
              <>
                <div className="category-content" style={{ width: "400px" }}>
                  {categoryVal && (
                    <CustomTree
                      title={categoryVal?.name || ""}
                      data={categoryVal?.subCategoryList || []}
                      defaultValue={value}
                      onSelect={handleCategorySelection}
                    />
                  )}
                </div>
              </>
            }
            open={addCategoryPopup}
            handleClose={() => {
              setAddCategoryPopup(false);
            }}
            footer={
              <>
                <BasicButton
                  type={"submit"}
                  isLoading={false}
                  isDisabled={false}
                  color="primary"
                  label={"Save"}
                  onClick={() => {
                    setAddCategoryPopup(false);
                  }}
                  size="large"
                  variant={"contained"}
                  endIcon={false}
                />
              </>
            }
          />
        </>
      )}
    </>
  );
}

export default CloseCategoryOption;
